@if (isDemo) {
  <app-standard-page>
    <div class="card vertical ms-0 container p-0">
      <div class="py-3 ps-3">
        <!-- <h3>Welcome to your FinQuery Fixed Assets demo register!</h3> -->

        <!-- Demo register only - unmanaged -->
        @if (hasOnlyDemoRegister && !isManaged) {
          <div class="row">
            <div class="col-6 col-lg-7">
              <p>
                This fully-featured register allows you to test FinQuery Fixed
                Assets' full functionality. You can play around without messing
                up anything important.
              </p>
              <p class="mb-0">
                When you're ready, you can create your own register and add your
                data.
              </p>
            </div>

            <div
              class="col-6 col-lg-5 demo-action justify-content-end align-items-end d-flex"
            >
              <button
                data-dd-action-name="demo-banner.create-register-button"
                type="button"
                class="btn btn-primary"
                trackingEvent="Demo Register - Create Register Clicked"
                (click)="openCreateRegisterModal()"
              >
                <i-lucide name="plus"></i-lucide>
                Create Your Asset Register
              </button>
            </div>
          </div>
        }

        <!-- Demo register only - managed -->
        @if (hasOnlyDemoRegister && isManaged) {
          <div class="row">
            <div class="col-6 col-lg-7">
              <p>
                This fully-featured register will allow you to test FinQuery
                Fixed Assets' full functionality.
              </p>
              <p class="mb-0">
                When you're ready you can create your own register to get
                started.
              </p>
            </div>
            <div
              class="col-6 col-lg-5 demo-action justify-content-end align-items-end d-flex"
            >
              <button
                data-dd-action-name="demo-banner.create-register-button"
                type="button"
                class="btn btn-outline w-100"
                trackingEvent="Demo Register - Create Register Clicked"
                (click)="openCreateRegisterModal()"
              >
                <i-lucide name="plus"></i-lucide>
                Create Register
              </button>
            </div>
          </div>
        }

        <!-- Has one other register -->
        @if (hasOneOtherRegister) {
          <div class="row">
            <div class="col-6 col-lg-7">
              <p>
                This fully-featured register allows you to test FinQuery Fixed
                Assets' full functionality. You can play around without messing
                up anything important.
              </p>

              <p class="mb-0">
                When you're ready you can continue with your own register.
              </p>
            </div>

            <div
              class="col-6 col-lg-5 demo-action justify-content-end align-items-end d-flex"
            >
              <a
                data-dd-action-name="demo-banner.first-register-link"
                class="btn btn-outline"
                [routerLink]="firstNonDemoRegisterLink"
                trackingEvent="Demo Register - Go To Register Clicked"
              >
                Setup Register: {{ firstNonDemoRegister?.name }}
              </a>
            </div>
          </div>
        }

        <!-- Has other registers -->
        @if (!hasOnlyDemoRegister && !hasOneOtherRegister) {
          <div class="row">
            <div class="col-6 col-lg-7">
              <p>
                This fully-featured register allows you to test FinQuery Fixed
                Assets' full functionality. You can play around without messing
                up anything important.
              </p>

              <p class="mb-0">
                When you're ready you can continue with your own registers.
              </p>
            </div>

            <div
              class="col-6 col-lg-5 demo-action justify-content-end align-items-end d-flex"
            >
              <a
                data-dd-action-name="demo-banner.all-registers-link"
                class="btn btn-outline"
                [routerLink]="registersLink"
                trackingEvent="Demo Register - Go To Registers Clicked"
              >
                See All Registers
              </a>
            </div>
          </div>
        }
      </div>
    </div>
  </app-standard-page>
}
